var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5H11M13 19.5H3C1.89543 19.5 1 18.6046 1 17.5V3.5C1 2.39543 1.89543 1.5 3 1.5H8.58579C8.851 1.5 9.10536 1.60536 9.29289 1.79289L14.7071 7.20711C14.8946 7.39464 15 7.649 15 7.91421V17.5C15 18.6046 14.1046 19.5 13 19.5Z",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDoc);
export default __webpack_public_path__ + "static/media/remove-doc.b3bd2277e1d6981b28ef4bbfa37ae1c0.svg";
export { ForwardRef as ReactComponent };